import type { FaireProductEntity } from "../../entity_types/product";

export const p_v2uh6vz75s: FaireProductEntity = {
  token: "p_v2uh6vz75s",
  type: "product",
  name: "18k GF Clear CZTennis Necklace with Seven Zirconia",
  brandToken: "b_9zxdpx73wa",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/eadd338b21fae2bc3b9fdd32137f035d0b950785e64fbbf77815694414d8f6ba.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2bedf76ac0f98c05ee79d622b7fa11ec62b040059b1e5bd6f8276647e6d037ca.jpeg",
    "https://cdn.faire.com/fastly/6999efe5d7fc45d2ef87931f13febc7c4a263528e739fdbab231cfeb08f65f77.jpeg",
    "https://cdn.faire.com/fastly/2e8e0f767454397b372d99dbecf3a92b0e450d0e0ad47eb48b4a8b688fe64b04.jpeg",
  ],
  priceDollars: 48.06,
  description:
    '18k GF Diamond CZ Tennis Necklace with Seven Zirconia Butterfly Charms Size 16"with 2"extension It is a symbol of a new life, letting go of old cycles and of finding one’s true inner self. The Butterfly calls on us to expand our awareness, spread our wings and move forward with joy and find our own place in life. The Butterfly can also remind us to make changes when the opportunity arises. Change and transformation are inevitable for all of us at one time or another in our lives, and this unwavering acceptance of metamorphosis by the Butterfly can be symbolic of faith allowing the wind to carry us forward to our new goals and dreams.',
  tags: [],
  msrpDollars: 96.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:42.861Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
